/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InstructionsAliases {
  HTML_VIEWER_INSTRUCTIONS = 'html-viewer-instructions',
  PANEL_HTML_VIEWER_INSTRUCTIONS = 'panel-html-viewer-instructions',
}
export { InstructionsAliases };
